export enum CurrencyCode {
  ARS = 'ARS',
  BRL = 'BRL',
  CLP = 'CLP',
  CRC = 'CRC',
  COP = 'COP',
  HNL = 'HNL',
  EUR = 'EUR',
  MXN = 'MXN',
  PEN = 'PEN',
  USD = 'USD',
}

export const PAGE_KEY = 'ats-admin';

export const MAX_STAGES_AVAILABLE = 30;

// Re-export GraphQL error types for convenience
export { GRAPHQL_ERROR_TYPES } from './constants/graphql-error-types';
